import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  CircleButton,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useDeleteWishlistPageItem} from '../hooks/useWishlistPageStream';

interface RemoveItemButtonProps {
  productId: number;
  onClickRemoveItem: VoidFunction;
  onClickRemoveItemSuccess: VoidFunction;
  onClickRemoveItemError: VoidFunction;
  iconType?: 'trash' | 'close';
  onShowConfirm?: VoidFunction;
}

export const RemoveItemButton = ({
  productId,
  onClickRemoveItem,
  onClickRemoveItemSuccess,
  onClickRemoveItemError,
  onShowConfirm,
  iconType = 'close',
}: RemoveItemButtonProps) => {
  const {t} = useTranslation();
  // this hook is expensive, only scoping it to the remove item button will reduce expensive re-render due to changes on the wishlist
  const onDelete = useDeleteWishlistPageItem();
  const handleClickButton = async () => {
    if (onShowConfirm) {
      onShowConfirm();
      return;
    }
    onClickRemoveItem();
    const result = await onDelete(productId);

    if (result) {
      onClickRemoveItemSuccess();
    } else {
      onClickRemoveItemError();
    }
  };

  return (
    <DeleteWisthlistItemButton
      data-testid="DeleteWishlistItemButton"
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        handleClickButton();
      }}
      aria-label={t('Remove from the wishlist')}
    >
      {iconType === 'close' ? (
        <AnimatedIcon
          size="S"
          asset={GenericIconName.Close}
          fill={COLORS.Grey1}
        />
      ) : (
        <AnimatedIcon
          size="M"
          asset={GenericIconName.Trash}
          fill={COLORS.Grey1}
        />
      )}
    </DeleteWisthlistItemButton>
  );
};

const AnimatedIcon = styled(Icon)`
  transition: fill 300ms ease;

  button:hover & {
    fill: ${COLORS.Black};
  }
`;

const DeleteWisthlistItemButton = styled(CircleButton)`
  display: flex;
  align-items: flex-start;
  padding: 0 5px;
  margin-top: -4px;
`;
